<template>
  <div class="bg-white" id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <News v-if="newsLoaded && this.type == 'full'" :news="news" :duration="duration"/>
    <NewsWidget v-if="newsLoaded && this.type == 'widget'" :news="news" :duration="duration"/>
    <NewsWall v-if="newsLoaded && this.type == 'wall'" :news="news"/>
  </div>
</template>

<script>
import News from './components/News.vue'
import NewsWidget from './components/NewsWidget.vue'
import NewsWall from './components/NewsWall.vue'

let url = new URL(window.location)
let params = new URLSearchParams(url.search.slice(1))
let type = params.get('type')
let source = params.get('source')
let duration = params.get('duration') * 1000

var config = {
  headers:
  {
    // 'X-Requested-With': "XMLHttpRequest"
    // 'Content-Type': 'application/json',
    // 'Accept': 'application/json'
  }
}

export default {
  name: 'App',
  components: {
    News,
    NewsWidget,
    NewsWall
  },
  data() {
    return {
      type: '',
      baseUrl: '',
      source: '',
      duration: '',
      news: [],
      rawNews: [],
      newsLoaded: false
    }
  },
  mounted() {
    this.source = source
    if (this.source) {
      this.loadNews()
    }
  },
  methods: {
    loadNews() {
      this.axios
        // .get('http://localcnow.com/tm/feeds/fe5m27pxl.xml',
        .get(this.baseUrl + this.source,
          config
        )
        .then(response => {
          console.log(response)
          this.rawNews = response.data
          this.newsLoaded = true
          this.type = params.get('type')
          this.source = params.get('source')
          this.duration = duration
          this.formatNews()
          }
        )
        .catch(error => {
          console.log(error)
        })
    },
    formatNews() {
      if (this.source == 'paikalliset_vahto_huoltopalvelut.json') {
        var formattedNews = this.rawNews.map(item => {
          this.news.push({
            title: item.title.rendered,
            body: item.excerpt.rendered,
            // body: item.content.rendered,
            // img: item.content.rendered.includes("<img"),
            source: "VAK intra - Paikalliset uutiset: Vahto Huoltopalvelut",
            date: item.date
          })
        })
      }
      if (this.source == 'paikalliset_vahto_tehdas.json') {
        var formattedNews = this.rawNews.map(item => {
          this.news.push({
            title: item.title.rendered,
            body: item.excerpt.rendered,
            // body: item.content.rendered,
            // img: item.content.rendered.includes("<img"),
            source: "VAK intra - Paikalliset uutiset: Vahto Tehdas",
            date: item.date
          })
        })
      }
      if (this.source == 'paikalliset_vantaa_huoltopalvelut.json') {
        var formattedNews = this.rawNews.map(item => {
          this.news.push({
            title: item.title.rendered,
            body: item.excerpt.rendered,
            // body: item.content.rendered,
            // img: item.content.rendered.includes("<img"),
            source: "VAK intra - Paikalliset uutiset: Vantaa huoltopalvelut",
            date: item.date
          })
        })
      }
      if (this.source == 'konserni.json') {
        var formattedNews = this.rawNews.map(item => {
          this.news.push({
            title: item.title.rendered,
            body: item.excerpt.rendered,
            // body: item.content.rendered,
            // img: item.content.rendered.includes("<img"),
            source: "VAK intra - Konserniuutiset",
            date: item.date
          })
        })
      }
      if (this.source == 'tiedotteet.json') {
        var formattedNews = this.rawNews.map(item => {
          this.news.push({
            title: item.title.rendered,
            body: item.content.rendered,
            // img: item.content.rendered.includes("<img"),
            source: "VAK intra - Tiedotteet",
            date: item.date
          })
        })
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  margin: 0;
  padding: 0;
}
html, body
{
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
